import { ViewportScroller } from '@angular/common';
import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { ForestDto } from '@system-shared/classes.dto';

@Component({
    selector: 'app-permit-information',
    templateUrl: './permit-information.component.html',
    styleUrls: ['./permit-information.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class PermitInformation implements OnInit {

  @Input() product: any;
  @Input() forest: ForestDto;
  @Output('next') next: EventEmitter<any> = new EventEmitter();
  @ViewChild('loginModal', {static: false}) loginModal: ElementRef;
  associatedCharges: number = 0;
  harvestDates: string = '';

  activeIndex = 0;
  navLinks = [
    { id: 'gettingMyPermit', name: 'How Do I Get a Permit?'},
    { id: 'howMuchDoesAPermitCost', name: 'What Does a Permit Cost?'},
    { id: 'howMuchCanIHarvest', name: 'How Much Can I Harvest?'},
    { id: 'whoCanUseThePermit', name: 'Who Can Use the Permit?'},
    { id: 'whereCanIHarvest', name: 'Where Can I Harvest?'},
    { id: 'whatCanIHarvest', name: 'What Can I Harvest?'},
    { id: 'howDoIHarvest', name: 'How Do I Harvest?'},
    { id: 'safetyTips', name: 'Safety Tips'},
    { id: 'whatAreThePermitRules', name: 'Permit Rules'},
    { id: 'additionalQuestions', name: 'Additional Questions'},
  ];

  constructor(
    private readonly viewPortScroller: ViewportScroller,
    private readonly route: ActivatedRoute,
    private readonly titleService: Title,
  ) {
    this.titleService.setTitle("USDA Forest Service E-Permits - Permit Information")
  }

  ngOnInit() {
    this.viewPortScroller.scrollToPosition([0, 0]);
    if (this.product.recommendations?.length) {
      let safetyTipsIndex = this.navLinks.findIndex((link: any) => link.id === 'safetyTips');
      this.navLinks.splice(safetyTipsIndex + 1, 0, { id: 'recommendations', name: 'Recommendations'});
    }
    this.route.fragment.subscribe((fragment) => {
      if (fragment) {
        this.activeIndex = this.navLinks.findIndex(navLink => { return navLink.id === fragment });
      }
    })
    if (this.product.associated_charges.length > 0) {
      this.product.associated_charges.forEach((ac) => { this.associatedCharges += ac.ac_per_uom })
    }

  }

  callNext() {
    this.next.emit();
  }

  formatUnitTypeText(units: number, unitType: string) {
    if (units !== 1 && unitType === 'Cord') {
      unitType += 's';
    }
    return `${units} ${unitType}`;
  }

  getHarvestDate(harvestDates: string) {
    if (harvestDates) {
      return harvestDates;
    } else if (this.forest.code === '0802' || this.forest.code === '0210') {
      return ''
    } else {
      return 'per';
    }
  }

  getMaxRemovalLimitText() {
    if (this.forest.code === '0802' || this.forest.code === '0210') {
      return 'for up to one year from point of issuance'
    } else {
      return 'calendar year'
    }
  }

  scroll(event: Event, elementId: string) {
    event.preventDefault();
    this.viewPortScroller.scrollToAnchor(elementId);
  }

  openLoginModal() {
    this.loginModal.nativeElement.style.display = 'block';
  }

  closeLoginModal() {
    this.loginModal.nativeElement.style.display = 'none';
  }

  toggleHover(element: HTMLElement | any) {
    element.classList.toggle('popup-hide');
  }
}
